export default __webpack_public_path__ + "static/media/mysql-original-wordmark.4e6fc768.svg";